<template>
  <tr :class="['clickable', { updated: isLastVisited(entity.id) }]" @click="goToDetail($event, entity.id)">
    <td class="no_padding drag_drop"><span></span></td>
    <td class="no_padding">
      <input type="checkbox"
             :id="entity.id"
             :value="entity.id"
             @click.stop
             @change="onChange"
             :checked="isChecked"
      />
      <label
          :for="entity.id"
          @click.stop
          v-translate>Vybrat
      </label>
    </td>
    <td :data-th="'Brand' | translate">
      <entity-link :id="entity.id_brand" type="brand">{{ entity.brand }}</entity-link>
    </td>
    <td :data-th="'Typ zařízení' | translate">
      <entity-link :id="entity.id_device_type" type="deviceType">{{ entity.device_type }}</entity-link>
    </td>
    <td :data-th="'Verze' | translate">{{entity.version}}</td>
    <td :data-th="'url' | translate">{{entity.url}}</td>
    <td :data-th="'Vloženo' | translate" v-html="$_date_formatFull(entity.date_created)"></td>
    <td :data-th="'Upraveno' | translate" v-html="$_date_formatFull(entity.date_updated)"></td>
    <td class="no_padding edit">
      <div class="edit_inner">
        <a
            v-if="$_deleteActionAllowed"
            class="btn btn_action btn_delete"
            :title="'Smazat' | translate"
            @click.prevent.stop="emitDelete">
          <translate class="translate">Smazat</translate>
        </a>
      </div>
    </td>
  </tr>
</template>

<script>
import rowActions from "@/components/mixins/row-actions"
import EntityLink from "../../common/EntityLink.vue";

export default {
  name: "VersionRedirectRow",
  components: { EntityLink },
  mixins: [rowActions],
  props: {
      entity: Object,
  },
  data() {
    return {
      moduleName: 'versionRedirects',
      detailPageRouteName: 'versionRedirectDetail',
    }
  },
  methods: {
    emitDelete() {
      this.$emit('delete', String(this.entity.id))
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/versionRedirect/VersionRedirectRow.vue